import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LanguagePickerComponent, TranslateCutPipe } from '@cf/features/i18n';
import { LinkComponent } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { MainLogoComponent } from '@cf/shared/ui/logos';
import { TextComponent } from '@cf/shared/ui/typography';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-booking-footer',
  templateUrl: './booking-footer.component.html',
  styleUrl: './booking-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxTolgeeModule,
    TextComponent,
    MainLogoComponent,
    NgIf,
    LinkComponent,
    CfIconDirective,
    TranslateCutPipe,
    LanguagePickerComponent,
  ],
})
export class BookingFooterComponent {
  @Input() isTouch!: boolean | null;
  @Input() isPreview!: boolean;
  @Input() showLogo!: boolean;
  @Input() cancellationPolicy!: string;
}
